import * as React from "react";
import { Admin, Resource } from 'react-admin';
import {
  FirebaseAuthProvider,
  FirebaseDataProvider,
} from 'react-admin-firebase';
import { CategoriesCreate, CategoriesEdit, CategoriesList, CategoriesShow } from "./categories";
import { ContentCreate, ContentEdit, ContentList, ContentShow } from "./content";
import { pubCreate, pubEdit, pubList, pubShow } from "./pub";
import { PlanCreate, PlanEdit, PlanList, PlanShow } from "./plan";



const config = {
  apiKey: "AIzaSyBcDca-DcyreuxxvxQLi8oJzlGMIGd8ELA",
  authDomain: "live-spectator.firebaseapp.com",
  databaseURL: "https://live-spectator-default-rtdb.firebaseio.com",
  projectId: "live-spectator",
  storageBucket: "live-spectator.appspot.com",
  messagingSenderId: "451840787291",
  appId: "1:451840787291:web:8be001ae608c94dda3d07e",
  measurementId: "G-5XBFMZNRB9"
};


const authProvider = FirebaseAuthProvider(config);
const dataProvider = FirebaseDataProvider(config);

const App = () => <Admin dataProvider={dataProvider}
  authProvider={authProvider}
>
  <Resource
    name="contents"
    list={ContentList}
    show={ContentShow}
    edit={ContentEdit}
    create={ContentCreate}
  />

  <Resource
    name="categories"
    list={CategoriesList}
    show={CategoriesShow}
    edit={CategoriesEdit}
    create={CategoriesCreate}
  />
  <Resource
    name="pub"
    list={pubList}
    show={pubShow}
    edit={pubEdit}
    create={pubCreate}
  />
  <Resource
    name="plans"
    recordRepresentation="title"
    list={PlanList}
    show={PlanShow}
    edit={PlanEdit}
    create={PlanCreate}
  />
</Admin>;

export default App;